export default __webpack_public_path__ + "static/media/waste-water.d1b81a89.png";